import React, { useState, useMemo, useCallback, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import _ from "lodash";
import useAsync from "react-use-async-hook";

import ProfileSetup from "./profileSetup/profileSetup";
import PasswordSetup from "./passwordSetup/passwordSetup";
import * as AuthAPI from "../../../api/auth";
import { useSetLoading } from "../../utils/hooks/loader";
import { doLogout } from "../../../utils";
import useGAEventTracker from "../../utils/hooks/GAEventsTracker";

const CreateProfile = () => {
    const [isNewUser, setNewUser] = useState(true);

    /**
     * Get User Details
     */
    const {
        data: userDetail,
        loading: getUserLoader,
        execute: executeGetUser,
    } = useAsync({
        autoExecute: false,
        task: useCallback(() => {
            return AuthAPI.isUserLoggedIn();
        }, []),
        dataLoader: useCallback(res => {
            return _.get(res, "data.data");
        }, []),
    });

    useEffect(() => {
        executeGetUser();
    }, []);

    useEffect(() => {
        if (userDetail) {
            if (!_.get(userDetail, "isNewUser")) {
                setNewUser(false);
            }
        }
    }, [userDetail]);

    const GAEventsTracker = useGAEventTracker("Logout Event");
    const handleLogout = () => {
        doLogout();
        GAEventsTracker("Profile logout");
    };

    const showLoader = useMemo(() => getUserLoader, [getUserLoader]);
    useSetLoading(showLoader);

    return !isNewUser ? (
        <Redirect to='/app' />
    ) : (
        <div className='createprofile-wrapper'>
            <div className='createprofile-content'>
                <div className='positioned-back text-center text-md-left'>
                    <Link to='/' className='btn-back'>
                        <i className='fas fa-arrow-left'></i>
                    </Link>
                    <h4 className='createprofile-name'>Create Profile</h4>
                    <Link to='#' onClick={handleLogout} className='btn-logout'>
                        Sign Out
                    </Link>
                </div>
                <div className='createprofile-form-wrapper'>
                    <ProfileSetup
                        setup={_.get(userDetail, "setup")}
                        userInfo={userDetail}
                        // doProfileSetup={this.props.doProfileSetup}
                        refreshUserDetail={executeGetUser}
                    />
                    <PasswordSetup
                        setup={_.get(userDetail, "setup")}
                        userInfo={userDetail}
                        // doPasswordSetup={this.props.doPasswordSetup}
                        refreshUserDetail={executeGetUser}
                    />
                </div>
            </div>
        </div>
    );
};

export default CreateProfile;
